import React, { FC, ReactElement } from 'react';
import { ContentCont, ContentText } from './DeleteConfirmationModal.styles';
import Modal from '../Modal/Modal';

export interface IDeleteConfirmationModal {
  active: boolean;
  actionLabel: string;
  cancelLabel: string;
  children?: ReactElement;
  title: string;
  text?: string;
  onConfirm: () => void;
  onClose: () => void;
}

const DeleteConfirmationModal: FC<IDeleteConfirmationModal> = ({
  active,
  actionLabel,
  cancelLabel,
  children,
  title,
  text,
  onConfirm,
  onClose
}) => (
  <Modal
    active={active}
    title={title}
    width="480px"
    buttonNames={{ action: actionLabel, cancel: cancelLabel }}
    callToAction={onConfirm}
    closeModal={onClose}
    top='150px'
  >
    <ContentCont data-testid="modal-content">
      {children || <ContentText>{text}</ContentText>}
    </ContentCont>
  </Modal>
);

export default DeleteConfirmationModal;
